import { render, staticRenderFns } from "./list.vue?vue&type=template&id=73a7be8a&scoped=true&"
import script from "./list.vue?vue&type=script&lang=js&"
export * from "./list.vue?vue&type=script&lang=js&"
import style0 from "./list.vue?vue&type=style&index=0&id=73a7be8a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73a7be8a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\project\\uniFrame\\uni-frame\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('73a7be8a')) {
      api.createRecord('73a7be8a', component.options)
    } else {
      api.reload('73a7be8a', component.options)
    }
    module.hot.accept("./list.vue?vue&type=template&id=73a7be8a&scoped=true&", function () {
      api.rerender('73a7be8a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/cate/list.vue"
export default component.exports